export default (value) => {
  if (value === '-') return value
  if (value || value === 0) return `R$ ${value}`
}
